import React from 'react';
import { Helmet } from 'react-helmet';

const Chatbot = () => {
  return (
    <div>
      <Helmet>
        <script>
          {`
            window.embeddedChatbotConfig = {
              chatbotId: "I0r0zS0jCkjzPwOolB9uE",
              domain: "www.chatbase.co"
            };
          `}
        </script>
        <script
          src="https://www.chatbase.co/embed.min.js"
          chatbotId="Si-fHrg38p18Y2PzBJe20"
          domain="www.chatbase.co"
          defer
        ></script>
      </Helmet>
    </div>
  );
};

export default Chatbot;
